import React from 'react';
import PageShell from '../components/PageShell';
import { Muted, PrimaryLink } from '../components/ui';

export default function NotFound() {
    return (
        <PageShell title="迷ヒ" en="404 · NOT FOUND">
            <Muted>此处空无一物。</Muted>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <PrimaryLink to="/">回到首页</PrimaryLink>
            </div>
        </PageShell>
    );
}
